import React from "react";
import ClientesView from "../views/ClientesView";
import DashboardView from "../views/DashboardView";
import EstadosFinancierosView from "../views/EstadosFinancierosView";
import FacturasView from "../views/FacturasView";
import GastosView from "../views/GastosView";
import HomeView from "../views/HomeView";
import NotasCreditoView from "../views/NotasCreditoView";
import PagosCobrosView from "../views/PagosCobrosView";
import ReportesView from "../views/ReportesView";

const contentByResource = {
  MCD: DashboardView,
  MCC: ClientesView,
  MCF: FacturasView,
  MCPC: PagosCobrosView,
  MCG: GastosView,
  MCN: NotasCreditoView,
  MCEF: EstadosFinancierosView,
  MCR: ReportesView,
  INI: HomeView,
};

const SistemaContableContent = ({ resource }) => {
  const View = contentByResource[resource.id] || HomeView;

  return <View />;
};

export default SistemaContableContent;
